<template>
  <div id="app">
    <!-- <video v-if="isLargeScreen" autoplay muted loop id="myVideo">
      <source src="./assets/videos/ElementsBG.mp4" type="video/mp4" />
      Your browser does not support HTML5 video.
    </video> -->
    <img v-if="isLargeScreen" id="myVideo" :src="backgroundImg" />
    <router-view class="routerView" />
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState({
      backgroundImg: (state) => state.auth.pageBackgroundImg,
    }),
  },
  setup() {
    const isLargeScreen = ref(window.innerWidth > 600)
    const deferredPrompt = ref(null)
    const showInstallButton = ref(false)

    const handleResize = () => {
      isLargeScreen.value = window.innerWidth > 600
    }

    onMounted(() => {
      window.addEventListener('resize', handleResize)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
    })

    return {
      isLargeScreen,
      showInstallButton,
    }
  },
}
</script>

<style lang="less">
#myVideo {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  max-width: 50%;
  object-fit: fill;
  filter: brightness(30%);
  z-index: -100;
}

@font-face {
  font-family: 'Insaniburger';
  src: url('font/insaniburger/Insanibu.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'AvertaStd-Regular';
  src: url('font/averta/AvertaStd-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'AvertaStd-Semibold';
  src: url('font/averta/AvertaStd-Semibold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'AvertaStd-Bold';
  src: url('font/averta/AvertaStd-Bold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'AvertaStd-Black';
  src: url('font/averta/AvertaStd-Black.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'AvertaStd-ExtraBold';
  src: url('font/averta/AvertaStd-ExtraBold.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

@media (max-width: 605px) {
  #myVideo {
    display: none;
  }
}

* {
  padding: 0;
  margin: 0;
}

#app,
body,
html {
  font-family: 'Saira', sans-serif;
  width: 100%;
  // background: #232322;
  background-image: url(./static/images/tree-gold.svg);
  background-position: center center;
  background-size: cover;
}

#app {
  max-width: 590px;
  margin: 0 auto;
  background: #215c93;
  background-image: url(./static/images/p9-bg.png) !important;
  background-repeat: repeat-y;
  background-position: top center !important;
  background-attachment: fixed;
  scrollbar-width: none;
  overflow-x: visible;
  background-size: 610px 100vh;

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, and Edge */
  }

  @media (max-width: 430px) {
    background-size: auto;
  }
}

.modal.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.app_bg {
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
}
.routerView {
  position: relative;
  z-index: 1;
}

div,
span,
p,
a {
  box-sizing: border-box;
}

a {
  text-decoration: none;
  outline: none;
}

.swiper-pagination-bullets {
  span {
    width: 10px;
    height: 10px;
    background: #fff !important;
    opacity: 1 !important;
    margin: 0 5px;
  }

  span.swiper-pagination-bullet-active {
    background: #44d464 !important;
  }
}

.button-mini-banner
  .swiper-pagination-bullets
  span.swiper-pagination-bullet-active {
  width: 48px;
  border-radius: 10px;
  background: #414446 !important;
}

form {
  .el-form-item__label {
    font-family: 'Saira', sans-serif;
    font-size: 14px;
    line-height: 24px;
    color: #002b34 !important;
    margin: 0 auto 10px;
    padding: 0 !important;
    display: contents;
    font-weight: 500;
  }

  div[element-loading-spinner='el-icon-loading'] {
    width: 28% !important;
    height: auto !important;
    line-height: 0;

    .el-image {
      width: 100% !important;
      height: auto !important;
    }
  }
}

p {
  margin: 0;
}

@keyframes glow {
  from,
  to {
    filter: drop-shadow(0 0 1vmin #ffff90);
  }
  50% {
    filter: none;
  }
}

@keyframes light {
  0% {
    transform: translate(560px, 0) rotate(0deg); /* Start at top-right corner */
  }

  25% {
    transform: translate(0, 0) rotate(80deg); /* Move to top-left corner */
  }

  50% {
    transform: translate(0, 175px) rotate(360deg); /* Move to bottom-left corner */
  }

  75% {
    transform: translate(560px, 175px) rotate(0deg); /* Move to bottom-right corner */
    opacity: 1;
  }

  100% {
    transform: translate(560px, 0) rotate(80deg); /* Return to top-right corner */
    opacity: 0;
  }
}

@keyframes lightLeft {
  0% {
    transform: translate(-50px, 0) rotate(0deg);
    opacity: 0;
  }

  25% {
    transform: translate(-285px, 0) rotate(180deg);
    opacity: 1;
  }

  50% {
    transform: translate(-285px, 170px) rotate(360deg);
  }

  75% {
    opacity: 1;
  }

  100% {
    transform: translate(0px, 170px) rotate(900deg);
    opacity: 0;
  }
}

@keyframes lightRight {
  0% {
    transform: translate(50px, 0) rotate(0deg);
    opacity: 0;
  }

  25% {
    transform: translate(265px, 0) rotate(180deg);
    opacity: 1;
  }

  50% {
    transform: translate(265px, -170px) rotate(360deg);
  }

  75% {
    opacity: 1;
  }

  100% {
    transform: translate(0px, -170px) rotate(900deg);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue